var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',[_c('div',[_c('navbar'),_c('div',{staticClass:"em"}),_c('div',{staticClass:"eek"},[_vm._v("Coming Soon!")]),_c('foot')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }